export const environment = {
  defaultPageSize: 10,
  apiUrl: 'https://localhost:7291',
  //apiUrl:'http://10.2.2.79:8060',
  appUrl: 'https://localhost:4200/',
  signalRUrl:"https://localhost:7291",
  attachmentMaxSize: 2, //mega
  skipCallingIAM:false,
  SDIFUrl:'http://dga.gov.sa/en/node/294'

};

